import { GET_PURCHASE_ORDER, RESET_REDUX_STATE, GET_PURCHASE_REQUIREMENT_DATA, SET_PRODUCTION_ORDER_NO } from "../constants";

const initialValue = {
    purchaseOrderData : "",
    purchaseRequirementData: [],
    headerValue: ""
}

const purchaseOrder = (state=initialValue, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_PURCHASE_ORDER: {
            return {
                ...state,
                purchaseOrderData: payload
            }
        }

        case GET_PURCHASE_REQUIREMENT_DATA: {
            return {
                ...state,
                purchaseRequirementData: payload
            }
        }

        case SET_PRODUCTION_ORDER_NO: {
            return {
                ...state,
                headerValue: payload
            }
        }

        case RESET_REDUX_STATE: {
            return initialValue
        }

        default:
            return state;
    }
}

export default purchaseOrder;